<template>
  <iframe ref="iframeRef" :src="anuualLink" frameborder="0" width="100%" :height="framerHeight"></iframe>
</template>

<script setup>
import { reactive, ref, computed, getCurrentInstance, onBeforeMount, nextTick, onMounted } from 'vue'

import { storeToRefs } from 'pinia';

import { useSystemStore } from '@/stores/system'
import { useUserStore } from '@/stores/user'
import UploadFile from '@/hooks/upload'
import { $cloneDeep } from '@/utils/lodashFuncs'
import { onActivated } from 'vue';

const props = defineProps({
  link: {
    type: String,
    default: ''
  },
  id: {
    type: String,
    default: ''
  }
})

const { proxy } = getCurrentInstance()
const userStore = useUserStore()
const systemStore = useSystemStore()

const { uid, userInfo } = storeToRefs(userStore)

const { customSetting, isMyOppo, isApp, isOneplus, cloudConfig, isWeb, isWap, versionCode } = storeToRefs(systemStore)

const iframeRef = ref(null)

const framerHeight = ref(642)

// 嵌套页链接
const anuualLink = computed(() => {
  // return `${location.origin}/abroadList`
  // return `https://communitytest.wanyol.com${customSetting.value.guestbookLink}`
  return props.link ? props.link : `${location.origin}${customSetting.value.guestbookLink}?t=${Date.now()}`
})

const darkMode = ref(false)


// iframe交互行为
const onHandleIframeAction = async (event) => {
  const { origin, data: receiveData } = event.data || {}
  // if (origin === location.origin) {
    console.log('iframe parent window receive message', event.data)
    const contentWindow = iframeRef.value.contentWindow
    switch (event.data.action) {
      // 页面初始化
      case 'init':
        console.log('iframe parent window post message', {
          nickname: userInfo.value.nickname || '',
          id: uid.value,
          avatar: userInfo.value.avatar,
          isApp: !!isApp.value,
          activityId: props.id || customSetting.value.noteActivityId
        })
        contentWindow.postMessage({
          nickname: userInfo.value.nickname || '',  // 昵称
          id: uid.value,  // 用户id
          avatar: userInfo.value.avatar,
          isApp: isApp.value, // 是否app
          activityId: props.id || customSetting.value.noteActivityId
        }, '*')
        // 暗色模式通知
        setInterval(() => {
          if (darkMode.value !== !!document.getElementsByClassName('dark').length) {
            const hasDarkClassName = !!document.getElementsByClassName('dark').length && isWap.value
            contentWindow.postMessage({
              action: 'switchDarkMode',
              isDark: hasDarkClassName
            }, '*')
            darkMode.value = hasDarkClassName
          }
        }, 1000);
        break
      case 'initFinish': 
        nextTick(() => {
          framerHeight.value = contentWindow.document.body.scrollHeight
        })
        break
      // 登录
      case 'signin':
        if (!uid.value) {
          const loginType = isOneplus.value && versionCode.value < 41600 ? 'h5' : ''
          userStore.onLogin({
            loginType
          })
        }
        break
      // iframe跳转（新窗口打开）
      case 'location':
        if (event.data.type === 'self') {
          location.href = event.data.url
        } else {
          if (isApp.value) {
            proxy.$openNewWebview(event.data.url, 'outterLink')
          } else {
            window.open(event.data.url)
          }
        }
        break
      // 埋点上报
      case 'trackEvent':
        const { event: trackEvent, params } = receiveData.info
        proxy.$ga(trackEvent, params)
        break
      // toast提示
      case 'showTips':
        const { message, duration } = event.data
        proxy.$toast({
          message,
          duration
        })
      default:
    }
  // }
}

onMounted(() => {
  nextTick(() => {
    // iframe通信监听
    window.addEventListener('message', onHandleIframeAction, false)
  })
})
</script>

<style scoped lang="postcss">
  iframe {
    display: flex;
  }
  @media screen and (min-width: 901px) {
    iframe {
      min-width: 1200px;
    }
  }
</style>